const getPercentage = (usedOperations, operationLimit) => {
  const percentage = (usedOperations / operationLimit) * 100;

  if (percentage > 100) {
    return 100;
  }

  return percentage;
};

export default getPercentage;
